import { encode } from 'js-base64';
window.authLogin = {
  apiUrl: '',
  is_test: false,
  def: '',
  config: {},
  onPost: false,
  dev: function () {
    var ua = navigator.userAgent.toLowerCase();
    console.log('ua', ua)
    var isWx = /micromessenger/i.test(ua);
    var isQQ = /qq/i.test(ua);
    var isDS = /godlike/i.test(ua);
    var isWb = /weibo/i.test(ua);
    var isLine = /line/i.test(ua);
    var isTt = /twitter/i.test(ua);
    var isFb = function () { var ua = navigator.userAgent || navigator.vendor || window.opera; return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1); }();
    var dev = '';
    console.log('isWx,isQQ,isDS,isWb,isLine', isWx, isQQ, isDS, isWb, isLine)
    if (isWx) {
      dev = 'weixin';
    } else if (isDS) {
      dev = '';
    } else if (isQQ) {
      dev = 'qq';
    } else if (isWb) {
      dev = 'weibo';
    } else if (isFb) {
      dev = 'facebook';
    } else if (isLine) {
      dev = 'line';
    } else if (isTt) {
      dev = 'twitter';
    }
    console.log('dev', dev)
    return dev;
  },
  urlps: function (a) { var b, c, d, e, f, g, h, i, j, k = ""; for (a.indexOf("#") >= 0 && (k = a.substr(a.indexOf("#") + 1, a.length), a = a.replace("#" + k, "")), b = "", a.indexOf("?") >= 0 && (b = a.substr(a.indexOf("?") + 1, a.length), a = a.replace("?" + b, "")), c = a, d = b.split("&"), e = d.length, h = [], i = [], f = 0; e > f; f++)g = d[f].split("="), h[g[0]] = g[1]; for (j = k.split("&"), e = j.length, f = 0; e > f; f++)g = j[f].split("="), i[g[0]] = g[1]; return { lists: function () { return h }, data: function (a, b) { if ("undefined" == typeof b) { var c = h[a.toLowerCase()]; return "undefined" == typeof c ? "" : c } h[a] = b }, hash: function (a, b) { if ("undefined" == typeof b) { var c = i[a.toLowerCase()]; return "undefined" == typeof c ? "" : c } i[a] = b }, getHash: function () { var a, b, c = []; for (a in i) i[a] && c.push(a + "=" + i[a]); return b = "", c.length > 0 && (b = c.join("&")), b }, url: function () { var a, b, d, e = []; for (a in h) h[a] && e.push(a + "=" + h[a]); b = "", e.length > 0 && (b = "?" + e.join("&")), e = []; for (a in i) i[a] && e.push(a + "=" + i[a]); return d = "", e.length > 0 && (d = "#" + e.join("&")), c + "" + b + d } } },
  check: function (pro) {
    if (!pro) {
      console.log('请配置当前产品代号');
      return;
    }
    //授权中转通用地址 https://game.163.com/callback/
    switch (pro) {
      case 'hy':
        authLogin.config.weiboAppid = 3105659870;
        authLogin.config.fbAppid = 362581687527744;
        authLogin.config.fbCallback = "https://www.knivesout.jp/callback/";
        authLogin.config.lineAppid = 1590337385;
        authLogin.config.lineCallback = "https://www.knivesout.jp/callback/";
        authLogin.config.ttCallback = "https://www.knivesout.jp/callback/";
        break;
      case 'ssr':
        authLogin.config.weiboAppid = 1581692899;
        authLogin.config.fbAppid = 181981313132544;
        authLogin.config.fbCallback = "https://www.onmyoji-card.com/callback/";
        authLogin.config.lineAppid = 1655092783;
        authLogin.config.lineCallback = "https://www.onmyoji-card.com/callback/";
        authLogin.config.ttCallback = "https://www.onmyoji-card.com/callback/";
        break;
      case 'mrzh':
        authLogin.config.weiboAppid = 1581692899;
        authLogin.config.fbAppid = 1142533622588358;
        authLogin.config.fbCallback = "https://www.lifeafter.game/callback/";
        authLogin.config.ttCallback = "https://www.lifeafter.game/callback/";
        break;
      case 'yys':
        authLogin.config.weiboAppid = 3084015878;
        authLogin.config.fbAppid = 723517304476519;
        authLogin.config.fbCallback = "https://www.onmyojigame.jp/callback/";
        authLogin.config.ttCallback = "https://www.onmyojigame.jp/callback/";
        break;
      case 'infinitelagrange':
        authLogin.config.fbAppid = 513605446085539;
        authLogin.config.lineAppid = 1656114565;
        authLogin.config.lineCallback = "https://www.infinitelagrange.com/callback/";
        authLogin.config.fbCallback = "https://www.infinitelagrange.com/callback/";
        authLogin.config.ttCallback = "https://www.infinitelagrange.com/callback/";
        break;
      case 'eclipse':
        authLogin.config.fbAppid = 446604786479590;
        authLogin.config.fbCallback = "https://www.eclipse.games/callback/";
        authLogin.config.ttCallback = "https://www.eclipse.games/callback/";
        break;
      case 'stzb':
        authLogin.config.weiboAppid = 1581692899;
        authLogin.config.ttCallback = "https://www.daisangoku.com/callback/";
        break;
      case 'stzb-kr':
        authLogin.config.fbAppid = 1682541428805942;
        authLogin.config.fbCallback = "https://www.infiniteborders.kr/callback/";
        authLogin.config.ttCallback = "https://www.infiniteborders.kr/callback/";
        break;
      case 'xy3d':
        authLogin.config.weiboAppid = 2756851256;
        break;
      case 'f7':
        authLogin.config.fbAppid = 2630103503872831;
        authLogin.config.fbCallback = "https://www.forevernana.com/callback/";
        authLogin.config.ttCallback = "https://www.forevernana.com/callback/"
        break;
      case 'g93':
        authLogin.config.weiboAppid = 1581692899;
        authLogin.config.fbAppid = 299888623969620;
        authLogin.config.fbCallback = "https://www.supermechachampions.com/callback/";
        authLogin.config.lineAppid = 1653370481;
        authLogin.config.lineCallback = "https://www.supermechachampions.com/callback/";
        authLogin.config.ttCallback = "https://www.supermechachampions.com/callback/";
        break;
      case 'g93tw':
        authLogin.config.weiboAppid = 1581692899;
        authLogin.config.fbAppid = 315324852516335;
        authLogin.config.fbCallback = "https://www.supermechachampions.com/callback/";
        authLogin.config.lineAppid = 1653370481;
        authLogin.config.lineCallback = "https://www.supermechachampions.com/callback/";
        authLogin.config.ttCallback = "https://www.supermechachampions.com/callback/";
        break;
      case '4wdgame':
        authLogin.config.fbAppid = 578961710159869;
        authLogin.config.fbCallback = "https://www.4wdgame.com/callback/";
        break;
      case 'eve':
        authLogin.config.fbAppid = 371081370126685;
        authLogin.config.fbCallback = "https://www.eveechoes.com/callback/";
        authLogin.config.ttCallback = "https://www.eveechoes.com/callback/";
        break;
      case 'g96':
        authLogin.config.fbAppid = 491526771661911;
        authLogin.config.fbCallback = "https://www.lotr-risetowar.com/callback/";
        authLogin.config.ttCallback = "https://www.lotr-risetowar.com/callback/";
        break;
      case 'ma96':
        authLogin.config.fbAppid = 671158550801693;
        authLogin.config.fbCallback = "https://www.neveraftergame.com/callback/";
        authLogin.config.ttCallback = "https://www.neveraftergame.com/callback/";
        break;
      case 'g92':
        authLogin.config.fbAppid = 525634611326844;
        authLogin.config.lineAppid = 1655982507;
        authLogin.config.lineCallback = "https://www.harrypottermagicawakened.com/callback/";
        authLogin.config.fbCallback = "https://www.harrypottermagicawakened.com/callback/";
        authLogin.config.ttCallback = "https://www.harrypottermagicawakened.com/callback/";
        break;
      case 'id5':
        authLogin.config.fbAppid = 578777605819697;
        authLogin.config.fbCallback = "https://www.identityvgame.com/callback/";
        authLogin.config.lineAppid = 1605075601;
        authLogin.config.lineCallback = "https://www.identityvgame.com/callback/";
        authLogin.config.ttCallback = "https://www.identityvgame.com/callback/";
        break;
      case 'ma100':
        authLogin.config.fbAppid = 430179884723572;
        authLogin.config.fbCallback = "https://www.dbdmobile-sea.com/callback/";
        authLogin.config.lineAppid = 1656940814;
        authLogin.config.lineCallback = "https://www.dbdmobile-sea.com/callback/";
        authLogin.config.ttCallback = "https://www.dbdmobile-sea.com/callback/";
        break;
      case 'ma135':
        authLogin.config.ttCallback = "https://www.clovertheater.jp/callback/";
        break;
      case 'g101':
        authLogin.config.fbAppid = 722257358608612;
        authLogin.config.fbCallback = "https://www.badlanders.game/callback/";
        authLogin.config.ttCallback = "https://www.badlanders.game/callback/";
        break;
      case 'g99':
        authLogin.config.lineAppid = 1657487051;
        authLogin.config.lineCallback = "https://www.foralltime.jp/callback/";
        authLogin.config.fbCallback = "https://www.foralltime.jp/callback/";
        authLogin.config.ttCallback = "https://www.foralltime.jp/callback/";
        break;
      case 'moba':
        authLogin.config.fbAppid = 513069255755418;
        authLogin.config.fbCallback = "https://www.onmyojiarena.us/callback/";
        break;
      default:
        authLogin.config.weiboAppid = 1581692899;
    }
    var myurl = authLogin.urlps(location.href);
    var dev = authLogin.dev() || authLogin.def;
    if (authLogin.def) {
      dev = authLogin.def;
    }
    // alert(`check dev` + dev)
    switch (dev) {
      case 'weixin':
      case 'qq':
      case 'weibo':
      case 'facebook':
      case 'line':
      case 'txMofang':
        if (myurl.data('code')) {
          return true;
        } else {
          return false;
        }
        break;
      case 'wxPay':
        if (myurl.data('auth_code')) {
          return true;
        } else {
          return false;
        }
        break;
      case 'twitter':
        if (myurl.data('oauth_token')) {
          return true;
        } else {
          return false;
        }
        break;
    }
  },
  go: function (opts) {
    var myurl = authLogin.urlps(location.href);
    // alert(`dev11 ${dev} ${authLogin.dev()} ${authLogin.def}`)
    var dev = authLogin.dev() || authLogin.def;
    if (authLogin.def) {
      dev = authLogin.def;
    }
    var scope = "";
    if (typeof opts != undefined) {
      for (var k in opts) {
        if (k == "scope") {
          scope = opts[k];
        } else {
          myurl.data(k, opts[k]);
        }
      }
    }
    myurl.data("code", "");
    myurl.data("auth_code", "");
    myurl.data("oauth_token", "");
    myurl.data("oauth_verifier", "");
    myurl.data("state", "");
    myurl.data("rurl", "");
    myurl.data("r", "");
    myurl.data("nie", "");
    var jurl = myurl.url();
    var toLink = '';
    const env = import.meta.env.VITE_ENV;
    // alert(`dev ${dev} ${authLogin.dev()} ${authLogin.def}`)
    switch (dev) {
      case 'weixin':
        if (!scope) {
          scope = "snsapi_userinfo";
        }
        if (location.host == "game.163.com") {
          toLink = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx85f583832dbd07e9&redirect_uri=" + encodeURIComponent(jurl) + "&response_type=code&scope=" + scope + "&state=163#wechat_redirect";
          // if (authLogin.is_test) {
          //   toLink = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx85f583832dbd07e9&redirect_uri=" + encodeURIComponent(jurl) + "&response_type=code&scope=" + scope + "&state=163#wechat_redirect";
          // } else {
          //   toLink = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx78c98dcf34e073b3&redirect_uri=" + encodeURIComponent(jurl) + "&response_type=code&scope=" + scope + "&state=163#wechat_redirect";
          // }
          // alert(`toLink22:${toLink}`);
        } else {
          var rdurl = 'https://game.163.com/chatcb/'
          // jurl = escape(jurl)
          jurl = encodeURIComponent(rdurl + '?source_uri=' + encodeURIComponent(jurl))
          toLink = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx85f583832dbd07e9&redirect_uri=' + jurl + '&response_type=code&scope=' + scope + '&state=163#wechat_redirect'
        }
        location.href = toLink;
        break;
      case 'qq':
        var rurl = encodeURIComponent('https://game.163.com/qqcallback/?u=' + encodeURIComponent(jurl));
        toLink = "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101465632&redirect_uri=" + rurl + "&scope=get_user_info";
        location.href = toLink;
        break;
      case 'wxPay':
        myurl.data("wxPay", "1");
        var jurl = myurl.url()
        const envLinkMap = new Map([
          ['production', 'https://allysdk3rd.matrix.netease.com'],
          ['preview', 'https://allysdk3rd.matrix.netease.com'],
          // ['preview', 'https://allysdk3rdprod.matrix.netease.com'],
        ])
        const envLink = envLinkMap.get(env) || 'https://allysdk3rdtest.matrix.netease.com'
        toLink = `${envLink}/server/games/g20/weixinpay/authorize/1.0.8?return_url=` +  encode(jurl);
        console.log(toLink);
        // alert(toLink)
        location.href = toLink;
        break;
      case 'txMofang':
        myurl.data("isMofang", "1");
        var jurl = myurl.url()
        const host = ['preview', 'production'].includes(env) ? 'https://mofang.163.com' : 'https://dev.mofang.163.com'
        var rurl = encodeURIComponent(jurl);
        toLink = `${host}/web/api/connect/wechat/authorize?appId=tx3_wx&responseType=code&redirectUri=` + rurl;
        // alert('准备授权积木：' + toLink)
        location.href = toLink;
        break;
      case 'weibo':
        jurl = 'https://game.163.com/weibo/callback/?link='+encodeURIComponent(jurl);
        // jurl = 'https://banzhuan.163.com/weibo/callback/?link=' + encodeURIComponent(jurl);
        jurl = encodeURIComponent(jurl);
        toLink="https://api.weibo.com/oauth2/authorize?response_type=code&client_id="+authLogin.config.weiboAppid+"&response_type=code&redirect_uri="+jurl;
        // toLink = "https://api.weibo.com/oauth2/authorize?response_type=code&client_id=3859936737" + "&response_type=code&redirect_uri=" + jurl;
        // alert(`toLink11:${toLink}`);
        location.href = toLink;
        break;
      case 'facebook':
        if (!authLogin.config.fbAppid) {
          console.log('当前产品没有配置Facebook的授权账号');
          return;
        }
        var state = encodeURIComponent(jurl);
        toLink = "https://www.facebook.com/dialog/oauth?client_id=" + authLogin.config.fbAppid + "&redirect_uri=" + encodeURIComponent(authLogin.config.fbCallback) + "&scope=public_profile,email&state=" + state;
        location.href = toLink;
        break;
      case 'line':
        if (!authLogin.config.lineAppid) {
          console.log('当前产品没有配置Line的授权账号');
          return;
        }
        var state = encodeURIComponent(jurl);
        toLink = "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=" + authLogin.config.lineAppid + "&redirect_uri=" + encodeURIComponent(authLogin.config.lineCallback) + "&scope=profile%20openid&state=" + state;
        location.href = toLink;
        break;
      case 'twitter':
        if (!authLogin.apiUrl) {
          console.log("miss apiUrl for twitter");
          return;
        }
        if (authLogin.onPost) {
          return;
        }
        authLogin.onPost = true;
        jurl = authLogin.config.ttCallback + "?link=" + encodeURIComponent(encodeURIComponent(jurl));
        $.ajax({
          url: authLogin.apiUrl,
          data: { 'oauth_callback': jurl },
          dataType: "jsonp",
          success: function (data) {
            authLogin.onPost = false;
            if (data.success == true) {
              location.href = "https://api.twitter.com/oauth/authorize?oauth_token=" + data.oauth_token;
            } else if (data.code == 200 && data.data) {
              location.href = "https://api.twitter.com/oauth/authorize?oauth_token=" + data.data;
            } else {
              alert(data.msg);
            }
          },
          error: function () {
            authLogin.onPost = false;
            alert('network error');
          }
        });
        break;
    }
  },
  subscribemsg: function (opts) {
    if (!opts) {
      opts = {};
    }
    if (typeof opts.scene == "undefined") {
      opts.scene = 0;
    }
    if (typeof opts.template_id == "undefined") {
      opts.template_id = "ztU3MvdeFsEXzSUC85sF4awRKql8pxL5_bp4bdA8sf8";
    }
    if (typeof opts.link == "undefined") {
      var myurl = authLogin.urlps(location.href);
      myurl.data("code", "");
      myurl.data("oauth_token", "");
      myurl.data("oauth_verifier", "");
      myurl.data("state", "");
      myurl.data("rurl", "");
      myurl.data("r", "");
      myurl.data("nie", "");
      var jurl = myurl.url();
      opts.link = 'https://game.163.com/callback/subscribemsg.html?link=' + encodeURIComponent(jurl);
    }
    location.href = "https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm&appid=wx85f583832dbd07e9&scene=" + opts.scene + "&template_id=" + opts.template_id + "&redirect_url=" + encodeURIComponent(opts.link) + "&reserved=163#wechat_redirect";
  },
  data: function (conf) {
    var pro = conf.pro || '';
    var loginErrorAutoJump = conf.loginErrorAutoJump;
    var apiUrl = conf.apiUrl;
    function getLoginInfo(cb) {
      var myurl = authLogin.urlps(location.href);
      var dev = authLogin.dev() || authLogin.def;
      var page_key = myurl.data("page_key");
      var share_key = myurl.data("share_key");
      var code = '';
      var ap = '';
      var dobj = { page_key: page_key, need_userinfo: 1 };
      if (share_key) {
        dobj = { share_key: share_key, need_userinfo: 1 };
      }
      switch (dev) {
        case 'weixin':
          code = myurl.data('code');
          dobj.code = code;
          ap = 'wx/login';
          break;
        case 'qq':
          code = myurl.data('code');
          dobj.code = code;
          dobj.redirect_uri = decodeURIComponent(myurl.data("rurl"));
          ap = 'qq/login';
          break;
        case 'weibo':
          code = myurl.data('code');
          dobj.code = code;
          dobj.redirect_uri = "https://game.163.com/weibo/callback/";
          ap = 'weibo/login';
          break;
        case 'facebook':
          code = myurl.data('code');
          dobj.code = code;
          dobj.redirect_uri = authLogin.config.fbCallback;
          ap = 'fb/login';
          break;
        case 'line':
          code = myurl.data('code');
          dobj.code = code;
          dobj.redirect_uri = authLogin.config.lineCallback;
          ap = 'line/login';
          break;
        case 'twitter':
          code = myurl.data('oauth_token');
          dobj.oauth_token = code;
          dobj.oauth_verifier = myurl.data("oauth_verifier");
          ap = 'twitter/login';
          break;
      }

      $.ajax({
        url: apiUrl + ap,
        data: dobj,
        dataType: "jsonp",
        success: function (data) {
          if (data.success == true) {
            cb(data);
          } else {
            if (!loginErrorAutoJump) {
              return;
            }
            if (!data.msg) {
              data.msg = data.error;
            }
            if (data.msg.indexOf('invalid') != -1) {
              authLogin.go();
            } else if (data.msg == '无效的Code：') {
              authLogin.go();
            } else if (data.msg.toLowerCase().indexOf('code') != -1) {
              authLogin.go();
            } else if (data.msg.toLowerCase().indexOf('req_id') != -1) {
              authLogin.go();
            } else if (data.msg.toLowerCase().indexOf('信息异常') != -1) {
              authLogin.go();
            } else if (data.msg.toLowerCase().indexOf('failed') != -1) {
              authLogin.go();
            } else if (data.msg.toLowerCase().indexOf('error') != -1) {
              authLogin.go();
            } else {
              alert(data.msg);
            }
          }
        },
        error: function () {
          alert('网络信号不好，请刷新再试');
        }
      });
    }
    var dev = authLogin.dev() || authLogin.def;
    // alert(`12321321 ${authLogin.dev()} ${authLogin.def}`)
    if (!dev) {
      authLogin.def = conf.def;//配置当前页面使用哪个平台的授权，可配置值 weixin,qq,weibo,facebook,line,twitter,不配置则自动判断当前所属平台，国内平台判断会正常，海外的判断不了平台，海外的项目需要指定一下
    }
    authLogin.apiUrl = apiUrl + 'twitter/request_token';//配置平台提供的获取推特request_token的链接
    if (!authLogin.check(pro)) {
      authLogin.go();
    } else {
      if (typeof conf.authCallback == 'function') {
        conf.authCallback();
      }
      getLoginInfo(function (ret) {
        if (typeof conf.authApiCallback == 'function') {
          conf.authApiCallback(ret);
        }
      });
    }
  }
}